import _regeneratorRuntime from "@babel/runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

import searchCategoryToIconIds2 from '../../data/searchCategoryToIconIds2.json';
import { PurchasedProvider } from './PurchasedProvider';
import * as iconSources from './iconSources';
export var PurchasedSearchNounProvider = /*#__PURE__*/function (_PurchasedProvider) {
  _inheritsLoose(PurchasedSearchNounProvider, _PurchasedProvider);

  function PurchasedSearchNounProvider() {
    return _PurchasedProvider.call(this, iconSources.TAGGED_PURCHASED_NOUN_SOURCE) || this;
  }

  var _proto = PurchasedSearchNounProvider.prototype;

  _proto.hasDefault = function hasDefault() {
    return false;
  };

  _proto.searchIcons = /*#__PURE__*/function () {
    var _searchIcons = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(searchTag
    /* , options = {} */
    ) {
      var icons;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              icons = searchCategoryToIconIds2[searchTag] || [];
              return _context.abrupt("return", icons.map(this.getIconById));

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function searchIcons(_x) {
      return _searchIcons.apply(this, arguments);
    }

    return searchIcons;
  }();

  return PurchasedSearchNounProvider;
}(PurchasedProvider);